import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { t } from 'i18next';
import PatientsDetailsFormPageComponent from '../components/patients-details-form-page';
import { PatientsDetailsPageComponent } from '../components/patients-details-page';
import PatientGuardComponent from '../components/patient-guard';
import { environment } from '../environments/environment';
import PaymentPageComponent from '../components/payment-page';
import PaymentSubmissionPageComponent from '../components/payment-submission-page';
import PaymentExpenseSubmissionPageComponent from '../components/payment-submission-page-expense';
import LayoutComponent from '../components/layout';
import { TopBarMode } from '../components/layout/topbar';

/**
 * Wrap every route inside a layout provider,
 * instead of the Outlet as this gives more control per screen
 * */
export const AuthedRouter = createBrowserRouter(
  [
    {
      path: '/',
      element: <PatientGuardComponent />,
      children: [
        {
          index: true,
          element: <Navigate to="payment" replace />,
        },
        {
          path: 'payment',
          element: (
            <LayoutComponent metaTitle={t('Payment Activity')}>
              <PaymentPageComponent />
            </LayoutComponent>
          ),
        },
        {
          path: 'payment/submission',
          element: (
            <LayoutComponent
              topBarMode={TopBarMode.BackButton}
              metaTitle={t('Submit a Request')}
              backTo="/payment"
            >
              <PaymentSubmissionPageComponent />
            </LayoutComponent>
          ),
        },
        {
          path: 'payment/submission/expense',
          element: (
            <LayoutComponent
              topBarMode={TopBarMode.BackButton}
              metaTitle={t('Submit an Expense')}
              backTo="/payment/submission"
            >
              <PaymentExpenseSubmissionPageComponent />
            </LayoutComponent>
          ),
        },
        {
          path: 'patient-details',
          element: (
            <LayoutComponent topBarMode={TopBarMode.NoNav}>
              <PatientsDetailsPageComponent />
            </LayoutComponent>
          ),
        },
        {
          path: 'patient-details/edit',
          element: (
            <LayoutComponent topBarMode={TopBarMode.NoNav}>
              <PatientsDetailsFormPageComponent />
            </LayoutComponent>
          ),
        },
      ],
    },
  ],
  {
    basename: environment.routingBasePath,
  }
);

export const PublicRouter = createBrowserRouter(
  [
    {
      path: '*',
      element: <PatientsDetailsPageComponent />,
    },
  ],
  {
    basename: environment.routingBasePath,
  }
);
